import type { Locale } from "@msuite/utils/locales";
import clsx from "clsx";
import "flag-icons/css/flag-icons.min.css";

/** Props Interface */
interface CountryFlagIconProps {
	locale: Locale | string;
}

export function CountryFlagIcon({ locale: _locale }: CountryFlagIconProps) {
	/** Props */
	const locale = _locale === "en" ? "gb" : _locale;

	/** Render */
	return (
		<div
			className={clsx(
				"self-center bg-red-400 bg-cover bg-center w-4 aspect-square",
				"rounded-full",
				`fi-${locale.toLowerCase()}`,
			)}
		/>
	);
}
